module.exports = __webpack_public_path__ + "static/media/Record.634efd5d.svg";